/* eslint-disable sort-keys */
import { useCallback, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { createLocale } from 'locales';

import type { CrumbType } from 'components-new/breadcrumbs/crumb';

import { useIntegrationSettingsContext } from 'state/context/organization/OrganisationSettings/IntegrationSettingsContext';

import organisationSettingsRoutes, {
  IntegrationSettingsBaseRoute,
} from 'pages/organization/OrganisationSettingsPage/integration-settings/organisation-settings-routes';

import useOrganisationSettingsIntegrationSelectTable from './use-organisation-settings-integration-select-table';

const globalLocalize = createLocale('global');
const localize = createLocale('organisationIntegrationSettingsLocales');

export type GenericImportedJobType = {
  id: string;
  date: string;
  title: string;
  function: string;
  start: string;
  end: string;
  pause: number;
  location: string;
};

interface UseOrganisationSettingsIntegrationSelectHandler {
  crumbs: CrumbType[];
  table: ReturnType<typeof useOrganisationSettingsIntegrationSelectTable>;
  updateSelectedJobs: () => void;
}

const useOrganisationSettingsIntegrationSelect =
  (): UseOrganisationSettingsIntegrationSelectHandler => {
    const navigate = useNavigate();

    const table = useOrganisationSettingsIntegrationSelectTable();

    useEffect(() => {
      if (table.data.length === 0) {
        navigate(IntegrationSettingsBaseRoute);
      }
    }, [navigate, table.data.length]);

    const {
      select: { setSelectedJobs },
    } = useIntegrationSettingsContext();

    const onCrumbClick = useCallback(
      (link: string) => {
        navigate(link);
      },
      [navigate],
    );

    const updateSelectedJobs = useCallback(() => {
      setSelectedJobs(table.selectedSdbJobs);
    }, [table.selectedSdbJobs, setSelectedJobs]);

    const crumbs = [
      {
        link:
          IntegrationSettingsBaseRoute +
          organisationSettingsRoutes.integrationSettings.path,
        name: globalLocalize('integrations'),
        onClick: () => {
          onCrumbClick(
            IntegrationSettingsBaseRoute +
              organisationSettingsRoutes.integrationSettings.path,
          );
        },
      },
      {
        link:
          IntegrationSettingsBaseRoute +
          organisationSettingsRoutes.sdbIntegration.path,
        name: localize('sdbIntegration'),
        onClick: () => {
          onCrumbClick(
            IntegrationSettingsBaseRoute +
              organisationSettingsRoutes.sdbIntegration.path,
          );
        },
      },
      {
        name: localize('selectJobs'),
      },
    ] as CrumbType[];

    return {
      crumbs,
      table,
      updateSelectedJobs,
    };
  };

export default useOrganisationSettingsIntegrationSelect;
